const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '实时更新',
    desc: '7×24小时不间断追踪，第一时间推送最新八卦新闻与内幕消息，让你永远快人一步。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度追踪',
    desc: '不满足于表面爆料，专业团队深挖事件背景，还原完整故事脉络与来龙去脉。',
  },
  {
    icon: 'ri-spy-line',
    title: '一手爆料',
    desc: '遍布娱乐圈的情报网络，独家获取明星网红第一手黑料，信息来源真实可靠。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方验证',
    desc: '每条爆料事件发布前均经多源交叉验证，确保内容真实可信，拒绝虚假谣言。',
  },
  {
    icon: 'ri-lock-line',
    title: '匿名投稿',
    desc: '严格保护爆料人隐私，支持完全匿名投稿通道，让知情者无后顾之忧地分享内幕。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">平台优势</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 text-center group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${feat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}